import Swiper from "swiper";
import bb from "blingblingjs";


// Set initial state
let state = {
	currentSlide : 0
}


// Get a reference to the icon dom nodes
const icons = bb(".js-el__pdp-benefits-icon");



// Initialise the swiper instances
const imageSwiper = new Swiper(".js-el__pdp-benefits-image", {});
const textSwiper = new Swiper(".js-el__pdp-benefits-text", {
	autoHeight: true
});


// If these swiper instances are present on the current page...
if(imageSwiper.controller && textSwiper.controller) {

	// link the instances together
	imageSwiper.controller.control = textSwiper;
	textSwiper.controller.control = imageSwiper;


	// Bind the click icon / index click event
	bb(".js-fn__pdp-benefits-go-to-index").on("click", e => {
		state.currentSlide = e.currentTarget.dataset.index;
		update();
	});

	imageSwiper.on('slideChange', () => {
		state.currentSlide = imageSwiper.activeIndex;
		update();
	});


	// Main update function to run after slides change
	function update(){

		if(imageSwiper.activeIndex != state.currentSlide){
			imageSwiper.slideTo(state.currentSlide);
		}

		icons.forEach(el => {
			el.classList.toggle('--is-active', el.dataset.index == state.currentSlide);
		})
	}


}